import { useContext, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/Button';
import PopupBabyList from 'pages/Chat/_components/CreateChat';
import MenuItem from 'pages/Chat/_components/MenuItem';
import { ChatContext } from 'pages/Chat/Chats';
import {
  setBabyId,
  setCurrentConversation,
  setDataCurrentConversation,
  setIsScrollToBottomListChat,
  setMessagesHistory,
  setPaginationConversations,
  setPaginationMessagesHistory,
  setLoadingScreenChat,
} from 'store/actions/chat';

const Menu = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { readMessages, getConversations } = useContext(ChatContext);

  const { conversations, paginationConversations, currentConversation, isScrollToBottomListChat } = useSelector((state) => state.chat);

  const [activeFilter, setActiveFilter] = useState(false);
  const [heightListChat, setHeightListChat] = useState(0);

  const refMenu = useRef(null);
  const refHeader = useRef(null);
  const listConversationsRef = useRef(null);

  const handleItemOverview = () => {
    const from = paginationConversations.total > 0 ? 1 : 0;
    const to = (paginationConversations.page - 1) * paginationConversations.page_size + 1 + paginationConversations.page_size - 1;
    const total = paginationConversations.total;

    return `${from} - ${to > total ? total : to} / ${total} ${t('ITEMS')}`;
  };

  useEffect(() => {
    if (refMenu.current && refHeader.current) {
      const heightMenu = refMenu.current;
      const heightHeader = refHeader.current;
      const headerStyle = window.getComputedStyle(heightHeader);

      const heightListChat = heightMenu.clientHeight - (heightHeader.clientHeight + parseFloat(headerStyle.marginBottom));

      setHeightListChat(heightListChat);
    }
  }, [refMenu.current, refHeader.current]);

  const handleClickConversation = async (conversation) => {
    dispatch(setLoadingScreenChat(true));
    if (currentConversation === conversation.conversation_id) {
      return;
    }
    await readMessages(currentConversation);
    dispatch(setMessagesHistory([]));
    dispatch(setPaginationMessagesHistory({ page: 1, page_size: 50, total: 0 }));
    dispatch(setCurrentConversation(conversation.conversation_id));
    dispatch(setDataCurrentConversation(conversation));
    dispatch(setBabyId(conversation?.participant_id || null));
    if (conversation?.is_unread) {
      await readMessages(conversation.conversation_id);
    }
    await getConversations(conversation.conversation_id);
    setTimeout(() => {
      dispatch(setLoadingScreenChat(false));
    }, 500);
  };

  // CHECK SCROLL IN END
  const checkScrollInEnd = () => {
    if (listConversationsRef.current && !isScrollToBottomListChat) {
      if (
        Math.ceil(listConversationsRef.current.scrollTop + listConversationsRef.current.clientHeight) + 5 >=
        listConversationsRef.current.scrollHeight
      ) {
        dispatch((dispatch, getState) => {
          dispatch(setIsScrollToBottomListChat(true));
          const paginationConversations = getState().chat.paginationConversations;
          dispatch(
            setPaginationConversations({
              ...paginationConversations,
              ...(paginationConversations.page + 1 <= Math.ceil(paginationConversations.total / paginationConversations.page_size)
                ? { page: paginationConversations.page + 1 }
                : {}),
            })
          );
        });
      }
    }
  };

  // ADD EVENT LISTENER SCROLL
  useEffect(() => {
    if (listConversationsRef.current) {
      listConversationsRef.current.addEventListener('scroll', checkScrollInEnd);
    }
    return () => {
      if (listConversationsRef.current) {
        listConversationsRef.current.removeEventListener('scroll', checkScrollInEnd);
      }
    };
  }, [listConversationsRef.current, isScrollToBottomListChat]);

  return (
    <div className="py-6 overflow-y-hidden h-full">
      <div className="h-full" ref={refMenu}>
        <div className="flex flex-col h-full px-4">
          <div className="px-4 mb-6" ref={refHeader}>
            <div className="flex gap-2 items-center justify-between">
              <h3 className="font-bold text-2xl text-black/85">{t('CHAT_LIST')}</h3>
              <PopupBabyList />
            </div>

            <div className="flex gap-2 items-center justify-between mt-4">
              <p className="text-sm text-gray-336">{handleItemOverview()}</p>

              <Button
                className={`text-sm filter w-35.5 h-10 ${activeFilter ? 'text-primary-346 border-primary-346' : ''}`}
                onClick={() => setActiveFilter(!activeFilter)}
                icon={
                  activeFilter ? (
                    <div className="relative mr-2.5">
                      <img src={require('assets/resources/FilterAltActive.svg').default} alt="plus icon" width={18} height={18} />
                    </div>
                  ) : (
                    <div className="relative mr-2.5">
                      <img src={require('assets/resources/FilterAlt.svg').default} alt="plus icon" width={18} height={18} />
                    </div>
                  )
                }
                text={t('FILTER_CHAT')}
                color="outline"
              />
            </div>
          </div>

          <div className="py-2 px-0 overflow-hidden" style={{ height: `${heightListChat}px` }}>
            <div id="list-conversations" className="flex flex-col overflow-scroll h-full px-4" ref={listConversationsRef}>
              {conversations.map((item) => (
                <MenuItem key={item.id} item={item} currentConversation={currentConversation} handleClickConversation={handleClickConversation} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
